import { Resource } from '@ekuaibao/fetch';
var dimensionsQueryMethod = new Resource('/api/v1/basedata/dimensions/queryMethod');
var dimensions = new Resource('/api/v1/basedata/dimensions');
export var getDimensionConfig = function (id) {
    return dimensions.GET("/[" + id + "]");
};
export var saveDimensionDisplayMethod = function (id, method) {
    return dimensionsQueryMethod.PUT("/$id/" + method, { id: id });
};
